import { EVENTS_BY_ACTIONS_MAP } from 'shared/constants';
import { ORGANIZATION_UPDATE } from 'shared/store/actions';
import AnalyticsService from '../../helpers/analytics.service';

export const analyticsByAction = () => next => async action => {
  next(action);

  if (EVENTS_BY_ACTIONS_MAP[action.type]) {
    AnalyticsService.track(EVENTS_BY_ACTIONS_MAP[action.type]);
  }
};

export const analyticsAddOrgId = () => next => async action => {
  next(action);

  if (action.type === ORGANIZATION_UPDATE) {
    AnalyticsService.setGroup({
      key: 'organization',
      value: action.payload?.name,
    });
    AnalyticsService.setGroup({
      key: 'organizationId',
      value: action.payload?.id,
    });
  }
};

export const analyticsMiddleware = [analyticsByAction, analyticsAddOrgId];
